import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'Netlink-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  constructor(
    private route: Router
  ) { }

  ngOnInit() {
    
  }
  navToPrivacy(){
    this.route.navigate(['/privacy']);
  }
}



// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/components/footer/footer.component.ts